import {HTTP} from "@/helpers/http-common"

const urlModule = 'archivo'

const downloadFile = (archivo) => new Promise((resolve,reject)=>{
  const {clave} = archivo;
  HTTP.get(
    `/api/${urlModule}/decargarArchivo/${clave}`
    , {responseType: 'blob'}
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});
const downloadFileDas = (archivo) => new Promise((resolve,reject)=>{
  const {clave} = archivo;
  HTTP.get(
    `/api/${urlModule}/descargarArchivoDas/${clave}`
    , {responseType: 'blob'}
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

const getLog = (archivo) => new Promise((resolve,reject)=>{
  const {clave} = archivo;
  HTTP.get(
    `/api/${urlModule}/getLog/${clave}`
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

const upload = (archivo) => new Promise((resolve,reject)=>{
  const {clave} = archivo;
  HTTP.get(
    `/api/${urlModule}/upload/${clave}`
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

const uploadDasWithError = (archivo) => new Promise((resolve,reject)=>{
  const {clave} = archivo;
  HTTP.get(
    `/api/${urlModule}/upload/dasWithError/${clave}`
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

const reprocesarRespuesta = (archivo) => new Promise((resolve,reject)=>{
  const {clave} = archivo;
  HTTP.post(
    `/api/${urlModule}/converter/response/rerun/`
    , {clave}
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

//Export methods
export default{
  getLog
  , downloadFile
  , downloadFileDas
  , upload
  , uploadDasWithError
  , reprocesarRespuesta
}



// WEBPACK FOOTER //
// ./src/services/archivo/index.js